import React from 'react';
import PropTypes from 'prop-types';

export const ArrowDown = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="17"
    height="28"
    viewBox="0 0 17 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.502 28c.304-.012.656-.137.877-.344l7.225-6.788c.414-.46.585-1.343.106-1.857-.471-.506-1.386-.491-1.86.013l-5.073 4.773V1.273C9.777.57 9.207 0 8.502 0c-.704 0-1.275.57-1.275 1.273v22.524l-5.073-4.773c-.436-.434-1.383-.514-1.86-.013-.477.502-.324 1.415.107 1.857l7.224 6.788c.248.231.538.345.877.344" />
  </svg>
);

ArrowDown.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const ArrowUp = ({ role, ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="17"
    height="28"
    viewBox="0 0 17 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.498 0c-.304.012-.656.137-.877.344L.396 7.132c-.414.46-.585 1.343-.106 1.857.47.506 1.386.491 1.86-.013l5.073-4.773v22.524a1.274 1.274 0 1 0 2.55 0V4.203l5.073 4.773c.436.434 1.383.514 1.86.013.477-.502.324-1.415-.107-1.857L9.375.344A1.234 1.234 0 0 0 8.498 0" />
  </svg>
);

ArrowUp.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const ArrowLeft = ({ role, ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="29"
    height="18"
    viewBox="0 0 29 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.5 9.002c.012.304.137.656.344.877l6.788 7.225c.46.414 1.343.585 1.857.106.506-.47.49-1.386-.013-1.86l-4.773-5.073h22.524a1.274 1.274 0 1 0 0-2.55H4.703l4.773-5.073c.434-.436.514-1.383.013-1.86C8.987.317 8.074.47 7.632.901L.844 8.125a1.234 1.234 0 0 0-.344.877" />
  </svg>
);

ArrowLeft.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const ArrowRight = ({ role, ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="29"
    height="18"
    viewBox="0 0 29 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M28.156 8.121L21.368.896C20.908.482 20.025.311 19.51.79c-.506.47-.491 1.386.013 1.86l4.773 5.073H1.773a.274.274 0 0 0 0 2.55h22.524l-4.773 5.073c-.434.436-.514 1.383-.013 1.86.502.477 1.415.324 1.857-.107l6.788-7.224c.23-.248.345-.538.344-.877-.012-.304-.137-.656-.344-.877z" />
  </svg>
);

ArrowRight.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const AngleDown = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="16"
    height="8"
    viewBox="0 0 16 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.902 1.684c.13-.13.13-.366 0-.522L14.832.118c-.132-.157-.367-.157-.525 0L9.761 4.685c-.418.526-2.561 1.148-3.502 0L1.686.118c-.131-.131-.367-.131-.524 0L.118 1.161A.373.373 0 0 0 0 1.435c0 .105.043.205.118.274l5.748 5.742c.367.34.837.549 1.334.549h1.594c.497 0 .968-.21 1.333-.549l5.776-5.768-.001.001z" />
  </svg>
);

AngleDown.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const AngleUp = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="16"
    height="8"
    viewBox="0 0 16 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.098 6.316c-.13.13-.13.366 0 .522l1.07 1.044c.132.157.367.157.525 0l4.546-4.567c.418-.526 2.561-1.148 3.502 0l4.573 4.567c.131.131.367.131.524 0l1.044-1.043A.373.373 0 0 0 16 6.565a.373.373 0 0 0-.118-.274L10.134.549C9.767.209 9.297 0 8.8 0H7.206c-.497 0-.968.21-1.333.549L.097 6.317l.001-.001z" />
  </svg>
);

AngleUp.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const AngleLeft = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="8"
    height="16"
    viewBox="0 0 8 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.316 15.902c.13.13.366.13.522 0l1.044-1.07c.157-.132.157-.367 0-.525L3.315 9.761c-.526-.418-1.148-2.561 0-3.502l4.567-4.573c.131-.131.131-.367 0-.524L6.839.118A.373.373 0 0 0 6.565 0a.373.373 0 0 0-.274.118L.549 5.866C.209 6.233 0 6.703 0 7.2v1.594c0 .497.21.968.549 1.333l5.768 5.776-.001-.001z" />
  </svg>
);

AngleLeft.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const AngleRight = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="8"
    height="16"
    viewBox="0 0 8 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.684 15.902c-.13.13-.366.13-.522 0l-1.044-1.07c-.157-.132-.157-.367 0-.525l4.567-4.546c.526-.418 1.148-2.561 0-3.502L.118 1.686c-.131-.131-.131-.367 0-.524L1.161.118A.373.373 0 0 1 1.435 0c.105 0 .205.043.274.118l5.742 5.748c.34.367.549.837.549 1.334v1.594c0 .497-.21.968-.549 1.333l-5.768 5.776.001-.001z" />
  </svg>
);

AngleRight.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const LongArrowRight = ({ role, ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="98"
    height="32"
    viewBox="0 0 98 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M96.916 11.747L85.505.196c-.259-.261-.724-.261-1.033 0l-2.065 2.143c-.31.261-.31.732 0 1.046l9.035 9.094c.465.47.104 1.306-.568 1.306H.724a.71.71 0 0 0-.724.732v2.98c0 .417.31.731.723.731h90.15c.673 0 1.034.784.569 1.255l-9.035 9.146c-.259.261-.259.732 0 1.045l2.065 2.09a.742.742 0 0 0 1.084 0l11.36-11.497C97.586 19.534 98 18.593 98 17.6v-3.189c0-.992-.414-1.933-1.084-2.665" />
  </svg>
);

LongArrowRight.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const LongArrowLeft = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="98"
    height="32"
    viewBox="0 0 98 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.084 11.747L12.494.196c.26-.261.725-.261 1.034 0l2.065 2.143c.31.261.31.732 0 1.046l-9.035 9.094c-.465.47-.104 1.306.568 1.306h90.15a.71.71 0 0 1 .724.732v2.98a.71.71 0 0 1-.723.731H7.127c-.673 0-1.034.784-.57 1.255l9.036 9.146c.259.261.259.732 0 1.045l-2.065 2.09a.742.742 0 0 1-1.084 0L1.084 20.267C.414 19.534 0 18.593 0 17.6v-3.189c0-.992.414-1.933 1.084-2.665" />
  </svg>
);

LongArrowLeft.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const LongArrowUp = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="32"
    height="98"
    viewBox="0 0 32 98"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.747 1.084L.197 12.495c-.262.26-.262.724 0 1.033l2.142 2.065c.261.31.732.31 1.046 0l9.094-9.035c.47-.465 1.306-.104 1.306.568v90.15a.71.71 0 0 0 .732.724h2.98a.71.71 0 0 0 .731-.723V7.127c0-.673.784-1.034 1.255-.569l9.146 9.035c.261.26.732.26 1.045 0l2.09-2.065a.742.742 0 0 0 0-1.084L20.267 1.084C19.534.414 18.593 0 17.6 0h-3.189c-.992 0-1.933.414-2.665 1.084" />
  </svg>
);

LongArrowUp.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const LongArrowDown = ({ role, ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="32"
    height="98"
    viewBox="0 0 32 98"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.747 96.916L.197 85.505c-.262-.26-.262-.724 0-1.033l2.142-2.065c.261-.31.732-.31 1.046 0l9.094 9.035c.47.465 1.306.104 1.306-.568V.724A.71.71 0 0 1 14.517 0h2.98a.71.71 0 0 1 .731.723v90.15c0 .673.784 1.034 1.255.569l9.146-9.035c.261-.26.732-.26 1.045 0l2.09 2.065a.742.742 0 0 1 0 1.084l-11.497 11.36C19.534 97.586 18.593 98 17.6 98h-3.189c-.992 0-1.933-.414-2.665-1.084" />
  </svg>
);

LongArrowDown.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};

export const ShortArrowDown = ({ role = 'presentation', ariaLabel, ...props }) => (
  <svg
    role={role}
    aria-label={ariaLabel}
    focusable="false"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.914 15.496c.115-.114.115-.32 0-.456l-.937-.91c-.115-.136-.32-.136-.458 0l-3.978 3.981c-.206.205-.572.046-.572-.25V.319a.312.312 0 0 0-.32-.319h-1.304a.312.312 0 0 0-.32.319V17.86c0 .296-.343.455-.549.25l-4.001-3.98c-.114-.114-.32-.114-.457 0l-.915.91a.329.329 0 0 0 0 .477l5.03 5.004c.32.296.732.478 1.167.478h1.395a1.73 1.73 0 0 0 1.166-.478l5.053-5.026z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

ShortArrowDown.propTypes = {
  role: PropTypes.string,
  ariaLabel: PropTypes.string
};
